import { TitleHelmet } from 'components/TitleHelmet/TitleHelmet';
import { PageTrackerWrapper } from 'queries/user/track';
import React from 'react';
import BudgetRoot from 'containers/Budgets/Budget/Loadable';
import BudgetsList from 'containers/Budgets/List/Loadable';
import BudgetsRoot from 'containers/Budgets/Loadable';

export const BudgetsRoutes = {
  path: 'budgets',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.budgets" />
      <BudgetsRoot />
    </>
  ),
  children: [
    {
      path: ':budgetId',
      element: <BudgetRoot />,
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="Budget - liste">
          <BudgetsList />
        </PageTrackerWrapper>
      ),
    },
  ],
};
